// src/components/Footer.jsx
import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} NIRVS.AI. All rights reserved.</p>
                <div className="footer-links">
                    <a href="mailto:nirvsai@gmail.com">Email</a>
                    <a href="https://www.youtube.com/@nirvsai" target="_blank" rel="noopener noreferrer">YouTube</a>
                    <a href="https://instagram.com/nirvs.ai" target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a href="https://www.tiktok.com/@nirvs.ai" target="_blank" rel="noopener noreferrer">TikTok</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
